// import { calculateCartData } from "@Globals/js/helper"

export const addDataLayer = params => {
  const {
    title,
    eventMsg = null,
    eventStatus = null,
    productInfo = null,
    productArray = null,
    isSticky = false,
    calculated_Values = "",
    isSampleOverlay = false,
    isSort = false,
    filterProps = null,
    toolTipProps = null,
    isAddtoCart = false,
    navProps = null,
    pdfProps = null,
    isDetailsTab = false,
    isTechnicalTab = false,
    isrecomendedProps = null,
    url = null,
    navTitle = null,
    breadCrumbObj = null,
    finishVal = null,
    shapeVal = null,
    colorVal = null,
    cartData = null,
    sysOverlayObj = null,
  } = params
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  const componentName = page?.category?.pageType
  const eventType =
    title === "add to compare" || title === "remove compare"
      ? "n/a"
      : "navigation"
  const calculatedValues =
    document.querySelector(".trim-calculator_main-block") &&
    calculated_Values?.length > 0
      ? JSON.parse(calculated_Values)
      : null
  const pdfData =
    pdfProps && pdfProps?.pdf_Data ? JSON.parse(pdfProps?.pdf_Data) : null
  const filterArrayJSON =
    filterProps &&
    filterProps.appliedFilters &&
    filterProps.appliedFilters.length > 0
      ? { filterArray: filterProps?.appliedFilters }
      : null
  const productInfoJSON =
    isAddtoCart && isSampleOverlay && productArray && productArray.length > 0
      ? { productArray: JSON.parse(productArray) }
      : productInfo && productInfo.length > 0
      ? { productInfo: JSON.parse(productInfo) }
      : null

  // if (cartData) {
  //   const { cart } = calculateCartData({ cart: cartData })
  //   page.cart = cart
  // }

  let eventAction,
    internalLinkZoneName,
    internalLinkPosition,
    internalLinkName,
    internalLinkType

  if (isSticky) {
    internalLinkZoneName = `${componentName}:sticky nav`
    eventAction = `${internalLinkZoneName}:${title}`
    internalLinkPosition = "header"
    if (title === "sticky nav links") {
      eventAction = `${componentName}:${title}`
      internalLinkName = `${navTitle}`
      internalLinkType = `${componentName}:navigation`
      internalLinkPosition = `${componentName}`
    }
  } else if (title === "notify me") {
    internalLinkZoneName = `${componentName}:modal:availability notification`
    eventAction = `${internalLinkZoneName}:${title}`
  } else if (
    title === "how much grout do i need" &&
    !isrecomendedProps?.isrecomended
  ) {
    internalLinkType = `${componentName}:navigation`
  } else if (title === "calculate footage" || title === "overage") {
    eventAction = `${componentName}:product details:calculate footage`
    internalLinkName =
      title === "calculate footage"
        ? "square feet changed"
        : "overage selection"
  } else if (title === "recommended grout" || title === "recommended trim") {
    internalLinkType = `${componentName}:navigation`
  } else if (
    title === "finish selection" ||
    title === "style selection" ||
    title === "color selection"
  ) {
    internalLinkType = `${componentName}:${title}:${
      title === "finish selection"
        ? finishVal
        : title === "color selection"
        ? colorVal
        : shapeVal
    }`
  } else if (toolTipProps?.isToolTip && !isDetailsTab) {
    internalLinkName = `${toolTipProps?.toolTipValue}`
    internalLinkType = `${componentName}:mouseover`
  } else if (navProps?.isNav) {
    internalLinkZoneName = `${componentName}:main content area`
    eventAction = `${internalLinkZoneName}:${title}`
    internalLinkName = `${navProps?.navTitle}`
    internalLinkType = `${componentName}:navigation`
  } else if (isSampleOverlay) {
    internalLinkZoneName = `${componentName}:order a sample overlay`
    eventAction = `${internalLinkZoneName}:${title}`
    if (filterProps?.isFilter) {
      internalLinkType = `${componentName}:filters`
      internalLinkName = filterProps?.filterName
        ? filterProps?.filterName
        : null
    } else if (isSort) {
      eventAction = `${internalLinkZoneName}:sort by`
      internalLinkType = `${componentName}:sort by`
    }
  } else if (isDetailsTab) {
    internalLinkZoneName = `${componentName}:details tab`
    eventAction = `${internalLinkZoneName}:${title}`
    if (pdfProps?.isPdf) {
      internalLinkName = pdfProps?.fileName
      internalLinkType = `${componentName}:download`
    } else if (toolTipProps?.isToolTip) {
      internalLinkName = toolTipProps?.toolTipValue
      internalLinkType = `${componentName}:mouseover`
    }
  } else if (isTechnicalTab) {
    internalLinkZoneName = `${componentName}:technical tab`
    eventAction = `${internalLinkZoneName}:${title}`
    internalLinkType = `${componentName}:navigation`
  } else if (isrecomendedProps?.isrecomended) {
    internalLinkZoneName = `${componentName}:${isrecomendedProps?.type}`
    eventAction = `${internalLinkZoneName}:${title}`
    internalLinkType = `${componentName}:${
      title === "close" ? "close" : "navigation"
    }`
    internalLinkName = isrecomendedProps?.tileName
      ? isrecomendedProps?.tileName
      : null
  } else if (breadCrumbObj) {
    eventAction = `${componentName}:${breadCrumbObj?.breadCrumbTitle}`
    internalLinkType = eventAction
    internalLinkName = `${breadCrumbObj?.breadCrumbPath}`
    internalLinkPosition = `${componentName}`
  } else if (sysOverlayObj) {
    const { overlayTitle, overlayType, sysVal } = sysOverlayObj
    eventAction = `${componentName}:product details:${overlayTitle}:${title}`
    internalLinkType = `${componentName}:${overlayType}${sysVal}`
    internalLinkZoneName = `${componentName}:product details:${overlayTitle}`
  }

  const eventInfo = {
    eventAction: eventAction || `${componentName}:product details:${title}`,
    eventName: eventAction || `${componentName}:product details:${title}`,
    eventType: eventType,
    eventMsg: eventMsg || "n/a",
    eventStatus: eventStatus || "n/a",
    internalLinkName: internalLinkName || `${title}`,
    internalLinkPosition: internalLinkPosition || `${componentName}`,
    internalLinkType: internalLinkType || `${componentName}:${title}`,
    internalLinkZoneName:
      internalLinkZoneName || `${componentName}:product details`,
    internalLinkURL: url || "n/a",
    clickInternalLinks: "true",
    ...pdfData,
    ...calculatedValues,
    ...filterArrayJSON,
  }

  window.adobeDataLayer.push({
    event: "cmp:click",
    eventInfo,
    page,
    ...productInfoJSON,
  })
}
